import React, { PropsWithChildren } from 'react';

export const LocationInputWrapper: React.FC<PropsWithChildren<{ divRef: React.RefObject<HTMLDivElement | null>; isOpen: boolean }>> = ({ children, divRef, isOpen }) => {
  return (
    <div className={`lg:relative ${isOpen ? 'left-0 top-0 z-50 bg-bg-primary max-lg:fixed max-lg:h-screen max-lg:w-screen max-lg:px-4' : 'space-y-2'}`} ref={divRef}>
      {children}
    </div>
  );
};
